import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { emailActivation } from '../../api/v1/post';
import { domainNameParser } from '../../helpers';

const EmailActivationPage = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Activating your email...');

  useEffect(() => {
    const handleEmailActivation = async () => {
      const actionToken = searchParams.get('action_token');
      const redirect = searchParams.get('redirect');

      if (actionToken && redirect) {
        try {
          await emailActivation({
            action_token: actionToken,
          });

          setMessage('Redirecting...');
          window.location.replace(`${domainNameParser(redirect)}/login`);
        } catch (error) {
          setMessage(
            `Oops there is an error! Code: ${error.response.status}, Message: ${error.response.data.message}`,
          );
        }
      }
    };

    handleEmailActivation();
  }, []);

  return (
    <div>
      <span>{message}</span>
    </div>
  );
};

export default EmailActivationPage;
